<template>
  <v-container>
    <v-card :class="{ 'mx-10': !$vuetify.breakpoint.xsOnly }">
      <v-card-title class="text-h5">Check-in</v-card-title>
      <v-stepper v-model="step">
        <!-- Paso 1: Cliente y Vehículo -->
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1"
            >Vehículo y Cliente</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2"
            >Solicitud de Trabajos</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 3" step="3"
            >Estado de la Unidad</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step step="4">Recepción y Entrega</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- Paso 1 -->
          <v-stepper-content step="1">
            <v-form ref="form">
              <v-subheader class="pl-0" style="height: 10pt">
                VEHÍCULO
              </v-subheader>
              <v-row class="pt-5 px-2 px-sm-10">
                <v-col cols="8" sm="10" class="pl-1 pr-1 pb-1">
                  <v-text-field
                    v-model="vehicleSelected.plate"
                    label="PATENTE"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
                <v-col cols="2" sm="1" class="d-flex justify-center">
                  <v-btn icon color="primary" @click="openVehicleModal">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="2" sm="1" class="d-flex justify-center">
                  <v-btn icon color="primary" @click="searchVehicle">
                    <v-icon>mdi-car-search</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pl-1 pr-1 pb-1">
                  <v-text-field
                    v-model="vehicleSelected.make"
                    label="MARCA"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="6" class="pl-1 pr-1 pb-1">
                  <v-text-field
                    v-model="vehicleSelected.model"
                    label="MODELO"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
              </v-row>

              <!-- Más secciones (usa el mismo enfoque): -->
              <v-row class="px-2 px-sm-10">
                <v-col cols="12" sm="4" class="pl-1 pr-1 pb-1">
                  <v-select
                    v-model="selectedTemplate"
                    :items="templates"
                    item-text="name"
                    item-value="id"
                    label="Servicio"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" class="pl-1 pr-1 pb-2">
                  <v-text-field
                    v-model="km"
                    label="KILOMETRAJE"
                    outlined
                    dense
                    hide-details
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row class="pt-2 px-2" dense>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="hasTestDrive"
                    label="TEST DRIVE"
                    hide-details
                    class="w-100 mt-0"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="greenCard"
                    label="CÉDULA VERDE"
                    hide-details
                    class="w-100 mt-0"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="warrantyManual"
                    label="MANUAL GTIA"
                    hide-details
                    class="w-100 mt-0"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="invoiceA"
                    label='FACTURA "A"'
                    hide-details
                    class="w-100 mt-0"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="insurance"
                    label="SEGURO"
                    hide-details
                    class="w-100 mt-0"
                  />
                </v-col>
              </v-row>

              <v-divider class="my-4" />
              <v-subheader class="pl-0"> CLIENTE </v-subheader>

              <!-- Última fila con datos de cliente -->
              <v-row class="px-2 px-sm-10">
                <v-col cols="8" sm="10" class="pl-1 pr-1 pb-2">
                  <v-text-field
                    v-model="dni"
                    label="DNI"
                    outlined
                    dense
                    hide-details
                    @keyup.enter="fetchClient"
                  />
                </v-col>
                <v-col cols="2" sm="1" class="d-flex justify-center">
                  <v-btn icon color="primary" @click="openClientModal">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="2" sm="1" class="d-flex justify-center">
                  <v-btn icon color="primary" @click="searchClient">
                    <v-icon>mdi-account-search</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="12" sm="6" class="pl-1 pr-1 pb-2">
                  <v-text-field
                    v-model="completeName"
                    label="NOMBRE"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="6" class="pl-1 pr-1 pb-2">
                  <v-text-field
                    v-model="clientSelected.address"
                    label="DIRECCION"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="6" class="pl-1 pr-1 pb-2">
                  <v-text-field
                    v-model="clientSelected.phone"
                    label="TELEFONO"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="6" class="pl-1 pr-1 pb-2">
                  <v-text-field
                    v-model="clientSelected.email"
                    label="EMAIL"
                    outlined
                    dense
                    hide-details
                    disabled
                  />
                </v-col>
              </v-row>

              <v-overlay :value="overlay" :z-index="3000">
                <v-progress-circular indeterminate size="64" />
              </v-overlay>
            </v-form>

            <v-card-actions class="mt-4">
              <v-spacer />
              <v-btn color="primary" @click="finishSteppVehicleClient()"
                >Siguiente</v-btn
              >
            </v-card-actions>
          </v-stepper-content>

          <!-- Paso 2 -->
          <v-stepper-content step="2">
            <v-form ref="formStep2">
              <v-container style="min-height: 300pt">
                <v-row>
                  <v-col cols="12" md="6" class="text-center pl-1 pr-1 pb-1">
                    <v-text-field
                      v-model="request"
                      label="Solicitud"
                      outlined
                      dense
                      hide-details
                      :disabled="requests.length >= countRequest"
                    />
                  </v-col>

                  <v-col cols="8" md="4" class="text-center pl-1 pr-1 pb-1">
                    <v-text-field
                      v-model="approximateBudget"
                      label="Presupuesto aproximado"
                      outlined
                      dense
                      hide-details
                      type="number"
                      :disabled="requests.length >= countRequest"
                    />
                  </v-col>

                  <v-col cols="4" md="2" class="text-center pl-1 pr-1 pb-1">
                    <v-btn
                      :disabled="requests.length >= countRequest"
                      color="info"
                      @click="addRequest()"
                      block
                    >
                      Agregar
                    </v-btn>
                  </v-col>

                  <!-- Campos dinámicos agregados por plantilla -->
                  <v-col v-for="(field, i) in requests" :key="i" cols="12">
                    <v-chip
                      class="ma-2"
                      color="info"
                      outlined
                      style="max-width: 100%; overflow-wrap: break-word"
                    >
                      <v-icon color="red" left @click="requests.splice(i, 1)">
                        mdi-delete
                      </v-icon>
                      {{ `${field.request} - ${field.approximateBudget ?? 0}` }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>

            <v-card-actions>
              <v-btn @click="step = 1" color="secondary">Atrás</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="nextStep">Siguiente</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <!-- Paso 3 -->
          <v-stepper-content step="3">
            <v-row class="pt-5 px-2 px-md-10">
              <!-- Imagen interactiva del vehículo -->
              <v-col cols="12" md="6" class="vehicle-map-wrapper">
                <div
                  class="vehicle-map-container"
                  @click="addMark"
                  ref="mapContainer"
                  style="position: relative; width: 100%; max-width: 100%"
                >
                  <img
                    src="/auto.png"
                    class="vehicle-image"
                    alt="Esquema vehículo"
                    style="width: 100%; height: auto"
                  />

                  <div
                    v-for="(mark, index) in marks"
                    :key="index"
                    class="marker"
                    :style="{ top: mark.y + '%', left: mark.x + '%' }"
                    @click.stop="removeMark(index)"
                    style="
                      position: absolute;
                      width: 15px;
                      height: 15px;
                      background-color: red;
                      border-radius: 50%;
                    "
                  ></div>
                </div>
              </v-col>

              <!-- Datos del estado del vehículo -->
              <v-col cols="12" md="6" class="scrollable-section">
                <v-row>
                  <!-- Observaciones -->
                  <v-col cols="8" sm="9" class="pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="observation"
                      label="Observación"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="requests.length >= 5"
                      :maxlength="8"
                      counter
                    />
                  </v-col>
                  <v-col cols="4" sm="3">
                    <v-btn
                      :disabled="observations.length >= 4"
                      color="info"
                      @click="addObservation()"
                      block
                    >
                      Agregar
                    </v-btn>
                  </v-col>

                  <!-- Lista de observaciones -->
                  <v-col
                    class="py-0"
                    v-for="(observation, i) in observations"
                    :key="i"
                    cols="12"
                  >
                    <v-chip
                      class="ma-2"
                      color="info"
                      outlined
                      style="max-width: 100%; overflow-wrap: break-word"
                    >
                      <v-icon
                        color="red"
                        left
                        @click="observations.splice(i, 1)"
                      >
                        mdi-delete
                      </v-icon>
                      {{ observation }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" class="pl-1 pr-1 pb-2">
                    <v-select
                      v-model="fuel"
                      :items="['1/4', '1/2', '3/4', '1 FULL']"
                      label="COMBUSTIBLE"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-row class="pt-2 pb-2 px-2" dense>
                    <v-col cols="12" md="12" class="pl-1 pr-1 pb-2">
                      <v-checkbox
                        v-model="vehicleState.isVehicleDirty"
                        label="UNIDAD SUCIA"
                        hide-details
                        class="w-100 mt-0"
                      />
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-checkbox
                        v-model="vehicleState.hasBelongings"
                        label="PERTENENCIAS"
                        hide-details
                        class="w-100 mt-0"
                      />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-checkbox
                        v-model="vehicleState.removesUsedParts"
                        label="RETIRA REPUESTOS USADOS"
                        hide-details
                        class="w-100 mt-0"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-col>
            </v-row>

            <v-card-actions style="margin-top: 20pt">
              <v-btn @click="step = 2" color="secondary">Atrás</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="finishSteppVehicleState()"
                >Siguiente</v-btn
              >
            </v-card-actions>
          </v-stepper-content>

          <!-- Paso 4 -->
          <v-stepper-content step="4">
            <v-form ref="formStep2">
              <v-container style="min-height: 300pt">
                <v-subheader class="pl-0 pb-5" style="height: 10pt">
                  RECEPCIÓN
                </v-subheader>
                <v-row>
                  <v-col cols="12" md="4" class="text-center pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="receivedBy"
                      label="Recepcionado por"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col cols="7" md="4" class="pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="date"
                      label="Fecha"
                      type="date"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" md="4" class="pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="timeFrom"
                      label="Hora"
                      type="time"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider class="my-4" />
                <v-subheader class="pl-0 pb-5" style="height: 10pt">
                  COMPROMISO DE ENTREGA
                </v-subheader>
                <v-row>
                  <v-col cols="12" md="4" class="text-center pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="deliveredBy"
                      label="Entregado por"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col cols="7" md="4" class="pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="estimatedDeliveryDate"
                      label="Fecha"
                      type="date"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" md="4" class="pl-1 pr-1 pb-2">
                    <v-text-field
                      v-model="estimatedDeliveryTime"
                      label="Hora"
                      type="time"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>

            <v-card-actions>
              <v-btn @click="step = 3" color="secondary">Atrás</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="submitForm">Guardar</v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <!-- Overlays -->
      <v-overlay :value="overlay" :z-index="3000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Modal para agregar Cliente -->
      <ClientDialog v-model="clientModal" @save-client="onClientSaved" />
      <!-- Modal para agregar Vehículo -->
      <v-dialog v-model="vehicleModal" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Agregar Vehículo</v-card-title>
          <v-card-text>
            <VehicleForm
              ref="vehicleForm"
              mode="add"
              :vehicleData="vehicle"
              source="servicio"
              :visibleFields="visibleFields"
              @save="addVehicle"
              @close="vehicleModal = false"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Modal para buscar Vehículo -->
      <v-dialog v-model="searchVehicleDialog" max-width="95vw" scrollable>
        <v-card class="pa-2">
          <v-card-title class="headline">Seleccionar Vehículo</v-card-title>

          <v-card-text>
            <v-text-field
              v-model="searchVeh"
              label="Buscar"
              outlined
              dense
              class="mb-4"
            ></v-text-field>

            <div class="table-wrapper">
              <v-data-table
                :headers="headersVehicle"
                :items="vehicles"
                item-value="id"
                dense
                :search="searchVeh"
                class="elevation-1 fixed-table"
                @click:row="selectVehicle"
              >
                <!--template v-slot:item="{ item }">
            <tr @click="selectVehicle(item)" class="clickable-row">
              <td>{{ item.plate }}</td>
              <td>{{ item.make }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.year }}</td>
              <td>{{ item.color }}</td>
            </tr>
          </template-->
              </v-data-table>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="searchVehicleDialog = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal para buscar Cliente -->
      <v-dialog v-model="searchClientDialog" max-width="800px">
        <v-card>
          <v-card-title class="headline">Seleccionar Cliente</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headersClient"
              :items="clients"
              item-value="id"
              dense
              class="elevation-1"
              :search="searchCli"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchCli"
                  label="Buscar"
                  outlined
                  dense
                  class="mx-4 small-input"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item }">
                <tr @click="selectClient(item)" class="clickable-row">
                  <td>{{ item.dni }}</td>
                  <td>{{ item.first_name }}</td>
                  <td>{{ item.last_name }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.address }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="searchClientDialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Diálogo de respuesta -->
      <v-dialog
        v-model="dialogMsg"
        max-width="500"
        persistent
        no-click-animation
      >
        <v-card>
          <v-card-title class="headline">{{ backendMessage }}</v-card-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>

            <!-- Botón de imprimir -->
            <v-btn color="primary" @click="printCheckin"> Imprimir </v-btn>

            <!-- Botón de aceptar/redireccionar -->
            <v-btn color="success" @click="redirect"> Aceptar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
        timeout="4500"
        color="red accent-2"
        elevation="2"
      >
        {{ msgSnackbar }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="showErrorSnackbar"
        :timeout="snackbarTimeout"
        color="red darken-2"
        top
        right
        multi-line
      >
        <div v-for="(error, index) in errors" :key="index">
          {{ error }}
        </div>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios.js";
import VehicleForm from "@/components/VehicleForm.vue";
import ClientDialog from "@/components/Client.vue";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
export default {
  components: { VehicleForm, ClientDialog },
  data() {
    return {
      estimatedDeliveryDate : null,
      estimatedDeliveryTime : null,
      deliveredBy : null,
      snackbar: false,
      msgSnackbar: null,
      serviceId: null,
      dialogMsg: false,
      backendMessage: "",
      hasTurn: false,
      observation: null,
      observations: [],
      vehicleState: {
        isVehicleDirty: false,
        hasBelongings: false,
        removesUsedParts: false,
      },
      hasTestDrive: false,
      receivedBy: null,
      date: null,
      timeFrom: null,
      approximateBudget: null,
      request: null,
      marks: [],
      km: null,
      fuel: null,
      greenCard: false,
      warrantyManual: false,
      invoiceA: false,
      insurance: false,
      step: 1,
      overlay: false,
      clientModal: false,
      vehicleModal: false,
      searchVehicleDialog: false,
      searchClientDialog: false,
      dni: "",
      completeName: "",
      price: null,
      date: null,
      selectedTemplate: null,
      templates: [],
      requests: [],
      client: {},
      vehicle: {
        id: null,
        make: "",
        model: "",
        year: "",
        version: "",
        plate: "",
        color: "",
        price: 0,
        position: "",
        factory_id: "",
        vin: "",
        motor_number: "",
      },
      clientSelected: {
        id: null,
        make: null,
        model: null,
      },
      vehicleSelected: {},
      visibleFields: [
        "make",
        "model",
        "year",
        "plate",
        "chassis_make",
        "chassis_number",
        "color",
        "motor_make",
        "motor_number",
        "certificate_number",
        "body_type",
        "status",
      ],
      clients: [],
      vehicles: [],
      searchCli: "",
      searchVeh: "",
      headersVehicle: [
        { text: "Patente", value: "plate" },
        { text: "Marca", value: "make" },
        { text: "Modelo", value: "model" },
        { text: "Año", value: "year" },
        { text: "Color", value: "color" },
        //{ text: "Precio", value: "price" },
      ],
      headersClient: [
        { text: "Dni", value: "dni" },
        { text: "Cuit", value: "cuit" },
        { text: "Nombre", value: "first_name" },
        { text: "Apellido", value: "last_name" },
        { text: "Correo Electrónico", value: "email" },
        { text: "Teléfono", value: "phone" },
        { text: "Dirección", value: "address" },
      ],
      countRequest: 6,
      errors: [],
      showErrorSnackbar: false,
      snackbarTimeout: 6000, // tiempo visible en ms: [],
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    headersVehicleResponsive() {
      if (window.innerWidth < 600) {
        return [
          { text: "Patente", value: "plate" },
          { text: "Marca", value: "make" },
          { text: "Modelo", value: "model" },
          { text: "Año", value: "year" },
        ];
      }
      return this.headersVehicle;
    },
  },
  mounted() {
    //Si viene con datos, cargar los datos en el formulario
    if (this.item) {
      this.serviceId = this.item.id;
      this.clientSelected = this.item.client;
      this.vehicleSelected = this.item.vehicle;
      this.selectedTemplate = this.item.template.id;
      this.dni = this.clientSelected.dni;
      this.completeName = `${this.clientSelected.first_name} ${
        this.clientSelected.last_name ?? ""
      }`;
      this.hasTurn = true;
    }
    this.getTemplates();
    this.getVehicles();
    this.setDateNow();
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  methods: {
    finishSteppVehicleState() {
      if (!this.fuel) {
        this.snackbar = true;
        this.msgSnackbar = `Faltan completar los siguientes campos: COMBUSTIBLE`;
        return;
      }
      this.receivedBy = this.user.name;
      this.setDateNow();
      this.nextStep();
    },
    finishSteppVehicleClient() {
      this.countRequest = 6;
      const missingFields = [];

      if (!this.vehicleSelected?.id) missingFields.push("Vehículo");
      if (!this.vehicleSelected?.plate) missingFields.push("Patente");
      if (!this.clientSelected?.id) missingFields.push("Cliente");
      if (!this.km) missingFields.push("Kilómetros");
      if (this.selectedTemplate === null) missingFields.push("Plantilla");
      //if (!this.dni) missingFields.push("DNI");
      if (missingFields.length === 0) {
        if (this.hasTestDrive) this.countRequest--;
        if (this.templates.length > 0) this.countRequest--;
        this.nextStep();
      } else {
        this.snackbar = true;
        this.msgSnackbar = `Faltan completar los siguientes campos: ${missingFields.join(
          ", "
        )}`;
      }
    },
    setDateNow() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Enero es 0
      const year = today.getFullYear();
      this.date = `${year}-${month}-${day}`;
      this.timeFrom = `${String(today.getHours()).padStart(2, "0")}:${String(
        today.getMinutes()
      ).padStart(2, "0")}`;
    },
    addRequest() {
      if (this.request) {
        this.requests.push({
          request: this.request,
          approximateBudget: this.approximateBudget,
        });
        this.request = null;
        this.approximateBudget = null;
      }
    },
    addObservation() {
      if (this.observation) {
        this.observations.push(this.observation);
        this.observation = null;
      }
    },
    getTemplates() {
      this.overlay = true;
      axios
        .get("/templates/getTemplates")
        .then((response) => {
          this.templates = [...response.data];
          /*this.templates.push({
            id: 0,
            name: "Otros",
          });*/
          this.overlay = false;
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    addMark(event) {
      const container = this.$refs.mapContainer;
      const rect = container.getBoundingClientRect();

      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      const xPercent = (offsetX / rect.width) * 100;
      const yPercent = (offsetY / rect.height) * 100;

      this.marks.push({ x: xPercent, y: yPercent });
    },
    removeMark(index) {
      this.marks.splice(index, 1);
    },
    async printCheckin() {
      // 1. Cargar PDF base desde assets o endpoint
      const existingPdfBytes = await fetch("/MODELO_DE_PRE_ORDEN.pdf").then(
        (res) => res.arrayBuffer()
      );
      // 2. Cargar documento
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      // 3. Definir fuente y estilo
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const { width, height } = firstPage.getSize();
      // RESPONSABLE DE RECEPCIÓN
      this.receivedBy && this.drawTextAt(firstPage, this.receivedBy, 338, height - 27, font);
      // RESPONSABLE DE ENTREGA
      this.deliveredBy && this.drawTextAt(firstPage, this.deliveredBy, 485, height - 27, font);
      // FECHA
      this.date && this.drawDate(firstPage, this.date, height, font);
      // HORA
      this.timeFrom && this.drawTime(firstPage, this.timeFrom, height, font);
      // FECHA ESTIMADA DE ENTREGA
      this.estimatedDeliveryDate && this.drawDateEstimated(firstPage, this.estimatedDeliveryDate, height, font);
      // HORA ESTIMADA DE ENTREGA
      this.estimatedDeliveryTime && this.drawTimeEstimated(firstPage, this.estimatedDeliveryTime, height, font);
      // HORA TÉCNICO
      this.technicianStart(firstPage, height, font);
      // CLIENTE
      this.drawClientInfo(firstPage, this.clientSelected, height, font);
      // VEHÍCULO
      this.drawVehicleInfo(
        firstPage,
        this.vehicleSelected,
        this.km,
        height,
        font
      );
      // CÍRCULOS DE DOCUMENTACIÓN
      this.drawCircleOption(firstPage, this.hasTurn, 130, 164, height - 208, 6);
      this.drawCircleOption(
        firstPage,
        this.hasTestDrive,
        301,
        335,
        height - 208,
        6
      );
      this.drawCircleOption(
        firstPage,
        this.greenCard,
        267,
        301,
        height - 146,
        6
      );
      this.drawCircleOption(
        firstPage,
        this.warrantyManual,
        327,
        369,
        height - 146,
        6
      );
      this.drawCircleOption(
        firstPage,
        this.invoiceA,
        393,
        429,
        height - 146,
        6
      );
      this.drawCircleOption(
        firstPage,
        this.insurance,
        504,
        538,
        height - 146,
        6
      );

      // TRABAJOS
      if (this.requests.length > 0) {
        this.drawRequests(firstPage, this.requests, height, font);
      }

      // OBSERVACIONES
      if (this.observations.length > 0) {
        this.drawObservations(firstPage, this.observations, height, font);
      }

      // ESTADO DEL VEHÍCULO
      this.drawVehicleStateOptions(firstPage, this.vehicleState, height);

      // 4. Dibujar las marcas en el PDF
      const circleRadius = 5; // tamaño del círculo
      const imageContainerWidth = 195; // ancho en el que se mostró la imagen en pantalla
      const imageContainerHeigh = 181; // ancho en el que se mostró la imagen en pantalla

      for (const mark of this.marks) {
        //const posX = (mark.x / 100) * imageContainerWidth;
        const posX = mark.x * 1.1;
        //const posY = (mark.y / 100) * imageContainerHeigh;
        const posY = mark.y * 1.7;

        firstPage.drawCircle({
          x: posX + 132, // ajustar según posición de la imagen en el PDF
          y: height - 723 - posY, // ajustar según posición de la imagen en el PDF
          size: circleRadius,
          color: rgb(1, 0, 0),
          borderColor: rgb(0.9, 0.9, 0.9),
          borderWidth: 0.5,
        });
      }
      // 5. Descargar el PDF generado
      /*const pdfBytes = await pdfDoc.save()
        const blob = new Blob([pdfBytes], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'preorden_completa.pdf'
        link.click()*/
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      // Crear una URL temporal
      const blobUrl = URL.createObjectURL(blob);

      // Abrir en una nueva ventana
      const printWindow = window.open(blobUrl);

      // Esperar a que se cargue y mandar a imprimir
      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
      };
    },
    nextStep() {
      this.step++;
    },
    checkTestDrive() {
      this.hasTestDrive &&
        this.requests.push({
          request: "Test Drive",
          approximateBudget: 0,
        });
    },
    asignFuel() {
      this.observations.unshift(`COMB:${this.fuel}`);
    },
    submitForm() {
      this.checkTestDrive();
      this.asignFuel();
      if (this.selectedTemplate != 25) {
        this.requests.unshift({
          request: this.templates.find(
            (template) => template.id === this.selectedTemplate
          ).name,
          approximateBudget: "",
        });
      }
      const estimatedDateDelivered = (this.estimatedDeliveryDate && this.estimatedDeliveryTime) ? `${this.estimatedDeliveryDate} ${this.estimatedDeliveryTime}` : null;
      // Aquí enviarías los datos
      const service = {
        service_id: this.serviceId,
        requests: this.requests,
        observations: this.observations,
        marks: this.marks,
        client_id: this.clientSelected.id,
        vehicle_id: this.vehicleSelected.id,
        template_id: this.selectedTemplate,
        km: this.km,
        fuel: this.fuel,
        hasTestDrive: this.hasTestDrive,
        hasTurn: this.hasTurn,
        greenCard: this.greenCard,
        warrantyManual: this.warrantyManual,
        invoiceA: this.invoiceA,
        isVehicleDirty: this.vehicleState.isVehicleDirty,
        hasBelongings: this.vehicleState.hasBelongings,
        removesUsedParts: this.vehicleState.removesUsedParts,
        insurance: this.insurance,
        receiver: this.receivedBy,
        dateReceived: `${this.date} ${this.timeFrom}`,
        estimatedDateDelivered: estimatedDateDelivered,
        deliveredBy : this.deliveredBy,
        date: this.date,
      };
      this.overlay = true;
      axios
        .post("/services/saveCheckin", service)
        .then((response) => {
          this.backendMessage = response.data.message;
          this.dialogMsg = true;
          this.overlay = false;
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
          this.overlay = false;
        });
    },
    redirect() {
      this.dialog = false;
      this.$router.push({ name: "services" }); // Asegúrate de tener esta ruta definida
    },
    openClientModal() {
      this.clientModal = true;
    },
    openVehicleModal() {
      this.$nextTick(() => {
        if (this.$refs.vehicleForm) {
          this.$refs.vehicleForm.clear();
        }
      });
      this.vehicleModal = true;
    },
    searchClient() {
      this.searchClientDialog = true;
      this.getClients();
      //if(!this.clients.length){
      //}
    },
    getClients() {
      this.overlay = true;
      axios
        .get("/clients/getClients")
        .then((response) => {
          this.clients = [...response.data];
          this.overlay = false;
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    searchVehicle() {
      this.searchVehicleDialog = true;
      this.getVehicles();
      //if(!this.vehicles.length){
      //}
    },
    getVehicles() {
      this.overlay = true;
      axios
        .get("/vehicles/getVehicles")
        .then((response) => {
          this.vehicles = [...response.data];
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    fetchClient() {
      this.overlay = true;
      axios
        .get("/clients/getClient", {
          params: {
            dni: this.dni,
          },
        })
        .then((response) => {
          if (!response.data) {
            //msg de aviso para realizar carga
            return;
          }
          this.clientSelected = response.data;
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onClientSaved(resp) {
      const client = resp.client;
      this.clientSelected = client;
      this.completeName = `${this.clientSelected.first_name} ${
        this.clientSelected.last_name ?? ""
      }`;
      this.dni = this.clientSelected.dni;
      this.clientModal = false;
      this.overlay = false;
    },
    addVehicle(data) {
      this.vehicle = data;
      this.overlay = true;
      axios
        .post("vehicles/register", this.vehicle)
        .then((response) => {
          this.vehicleSelected = response.data.vehicle;
          this.plate = this.vehicleSelected.plate;
          this.vehicleModal = false;
          this.overlay = false;
          //this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
          this.errors = [];
          if (err.response && err.response.status === 422) {
            const serverErrors = err.response.data.errors;
            for (let field in serverErrors) {
              this.errors.push(...serverErrors[field]);
            }
          } else {
            this.errors.push(
              "Ocurrió un error inesperado al guardar el vehículo."
            );
            console.error(err);
          }
          this.showErrorSnackbar = true;
        });
    },
    selectClient(client) {
      this.clientSelected = client;
      this.completeName = `${this.clientSelected.first_name} ${
        this.clientSelected.last_name ?? ""
      }`;
      this.dni = client.dni;
      this.searchClientDialog = false;
    },
    selectVehicle(item) {
      this.vehicleSelected = item;
      this.searchVehicleDialog = false;
    },
    openDialog(action, sale = null) {
      this.action = action;
      this.clearFormSale();
      if (this.action === "edit") {
        this.sale.id = sale.id;
        this.price = sale.price;
        this.date = sale.sale_date;
        this.selectVehicle(sale.vehicle);
        this.selectClient(sale.client);
      }
      this.dialog = true;
      this.dialogTitle = action === "edit" ? "Editar" : "Nueva";
      this.isList = false;
      this.isEdit = true;
    },
    drawTextAt(page, text, x, y, font, size = 9) {
      page.drawText(text, {
        x,
        y,
        size,
        font,
        color: rgb(0, 0, 0),
      });
    },

    drawDate(page, date, height, font) {
      const [year, month, day] = date.split("-");
      this.drawTextAt(page, day, 335, height - 48, font);
      this.drawTextAt(page, month, 370, height - 48, font);
      this.drawTextAt(page, year, 415, height - 48, font);
    },
    drawDateEstimated(page, date, height, font) {
      const [year, month, day] = date.split("-");
      this.drawTextAt(page, day, 485, height - 48, font);
      this.drawTextAt(page, month, 520, height - 48, font);
      this.drawTextAt(page, year, 565, height - 48, font);
    },
    drawTimeEstimated(page, time, height, font) {
      const [hour, minute] = time.split(":");
      this.drawTextAt(page, hour, 485, height - 68, font);
      this.drawTextAt(page, minute, 520, height - 68, font);
    },
    drawTime(page, time, height, font) {
      const [hour, minute] = time.split(":");
      this.drawTextAt(page, hour, 335, height - 68, font);
      this.drawTextAt(page, minute, 370, height - 68, font);
    },
    technicianStart(page, height, font) {
      const now = new Date();
      const hours = now.getHours()
      const minutes = now.getMinutes();
      this.drawTextAt(page, `${hours}:`, 372, height - 105, font);
      this.drawTextAt(page, minutes.toString(), 387, height - 105, font);
    },
    drawClientInfo(page, client, height, font) {
      this.drawTextAt(
        page,
        `${client.first_name} ${client.last_name ?? ""}`,
        115,
        height - 135,
        font
      );
      this.drawTextAt(page, client.phone ?? "", 85, height - 160, font);
      this.drawTextAt(page, client.email ?? "", 68, height - 180, font);
      this.drawTextAt(page, client.cuit ?? "", 338, height - 180, font);
    },

    drawVehicleInfo(page, vehicle, km, height, font) {
      this.drawTextAt(page, vehicle.model, 340, height - 135, font);
      this.drawTextAt(page, vehicle.plate ?? "", 530, height - 135, font);
      this.drawTextAt(page, km, 443, height - 150, font);
    },

    drawCircleOption(
      page,
      condition,
      xTrue,
      xFalse,
      y,
      radius,
      borderColor = rgb(0, 0, 0)
    ) {
      page.drawEllipse({
        x: condition ? xTrue : xFalse,
        y,
        xScale: radius,
        yScale: radius,
        borderColor,
        borderWidth: 1,
      });
    },

    drawRequests(page, requests, height, font) {
      let posY = 226;
      let total = 0;
      for (const item of requests) {
        const value = (item.approximateBudget == 0 || !item.approximateBudget) ? '' :  item.approximateBudget;
        posY += 42;
        this.drawTextAt(page, item.request, 63, height - posY, font);
        this.drawTextAt(page, value, 530, height - posY, font);
        total += item.approximateBudget ? Number(item.approximateBudget) : 0;
      }
      //TOTAL
      this.drawTextAt(page, total.toString(), 550, height - 655, font);
    },

    drawObservations(page, observations, height, font) {
      let posY = 792;
      for (const obs of observations) {
        posY += 12;
        this.drawTextAt(page, obs, 48, height - posY, font);
      }
    },

    drawVehicleStateOptions(page, state, height) {
      this.drawCircleOption(
        page,
        state.isVehicleDirty,
        54,
        74,
        height - 756,
        7
      );
      this.drawCircleOption(page, state.hasBelongings, 54, 74, height - 785, 7);
      this.drawCircleOption(
        page,
        state.removesUsedParts,
        54,
        74,
        height - 888,
        7
      );
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.fixed-table {
  /* min-width: 900px; /* Asegura espacio para todas las columnas */
}

.v-dialog {
  max-width: 95vw !important;
  width: 95vw !important;
}

.v-card {
  max-height: 90vh;
  overflow-y: auto;
}
.clickable-row {
  cursor: pointer;
}
.vehicle-map-wrapper {
  overflow-x: auto;
}

.vehicle-map-container {
  position: relative;
  display: inline-block;
  width: 200pt; /* igual que la imagen */
  height: auto;
  cursor: crosshair;
}

.vehicle-image {
  width: 100%; /* se ajusta al contenedor */
  display: block;
}

.marker {
  position: absolute;
  width: 25px;
  height: 25px;
  background-color: red;
  border-radius: 50%;
  border: 3px solid white;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.scrollable-section {
  max-height: 300pt; /* o el alto que desees */
  overflow-y: auto;
  padding-right: 8px; /* opcional: espacio para la scrollbar */
}
</style>
